export const TaskTemplateTarget = {
    taskType: 'TASK_TYPE',
    resolutionCode: 'RESOLUTION_CODE'
}